export default __webpack_public_path__ + "static/media/tag.1f7e75af.svg";